(() => {
  const selector = '[data-home-carousel-products]';

  function init(dataEl) {
    const section = dataEl.closest('.cs-home-carousel-2-section');
    if (!section || section.dataset.homeCarouselReady) return;
    let products;
    try {
      products = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }
    section.dataset.homeCarouselReady = 'true';
    const cleanups = [];
    const listen = (el, type, handler) => {
      el.addEventListener(type, handler);
      cleanups.push(() => el.removeEventListener(type, handler));
    };
    const links = section.querySelectorAll('[data-home-carousel-link]');
    links.forEach(link => listen(link, 'click', event => {
      const url = link.dataset.selectedVariantUrl;
      if (!url || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      window.location.assign(url);
    }));

    section.querySelectorAll('[data-home-carousel-card]').forEach(card => {
      const swatches = card.querySelectorAll('.color-btn');
      const cardLinks = card.querySelectorAll('[data-home-carousel-link]');
      const image = card.querySelector('.carousel-image-link img');
      swatches.forEach(swatch => listen(swatch, 'click', () => {
        swatches.forEach(button => {
          const selected = button === swatch;
          button.classList.toggle('active', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        if (swatch.dataset.img && image) image.src = swatch.dataset.img;
        cardLinks.forEach(link => {
          if (swatch.dataset.url) link.dataset.selectedVariantUrl = swatch.dataset.url;
        });
      }));
    });

    const root = section.querySelector('#product-carousel-2_pc');
    let timer;
    let revealTimer;
    let generation = 0;
    const image = root && root.querySelector('.carousel-image');
    if (root && products.length) {
      const title = root.querySelector('.carousel-title');
      const tag = root.querySelector('.carousel-tag');
      const desc = root.querySelector('.carousel-desc');
      const slogan = root.querySelector('.carousel-slogan');
      const params = root.querySelector('.carousel-params');
      const colors = root.querySelector('#product-carousel-2-color-con');
      const productLinks = root.querySelectorAll('[data-home-carousel-link]');
      const indicators = section.querySelectorAll('.carousel_pc-indicator-item');
      const elements = [title, tag, desc, slogan, params, image];
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const normalize = value => String(value || '').toLowerCase().replace(/\s+/g, '_');
      let current = 0;

      function render(index, fade = true) {
        clearTimeout(timer);
        clearTimeout(revealTimer);
        const version = ++generation;
        image.onload = null;
        image.onerror = null;
        const show = () => {
          if (version !== generation) return;
          clearTimeout(revealTimer);
          elements.forEach(el => {
            el.classList.remove('opacity-0');
            el.classList.add('opacity-100');
          });
        };
        function update() {
          if (version !== generation) return;
          const product = products[index];
          title.textContent = product.title;
          desc.textContent = product.desc;
          slogan.textContent = product.slogan;
          tag.textContent = product.tag || '';
          tag.style.display = product.tag ? '' : 'none';
          productLinks.forEach(link => {
            link.href = product.link;
            link.setAttribute('aria-label', link.classList.contains('carousel-image-link') ? product.title : `Learn More about ${product.title}`);
            delete link.dataset.selectedVariantUrl;
          });
          image.width = product.p_image_w;
          image.height = product.p_image_h;
          image.alt = product.p_image_alt || product.title;
          let values = [];
          try {
            values = typeof product.params === 'string' ? JSON.parse(product.params) : product.params;
          } catch (error) {}
          params.replaceChildren();
          if (Array.isArray(values)) values.forEach(value => {
            const row = document.createElement('div');
            const amount = document.createElement('div');
            const label = document.createElement('div');
            row.className = 'text-right';
            amount.className = 'text-white !text-3xl !font-semibold';
            label.className = '!text-[#7f7f7f] !text-lg !font-medium !mt-1 md:w-full';
            amount.textContent = value.value;
            label.textContent = value.key;
            row.appendChild(amount);
            row.appendChild(label);
            params.appendChild(row);
          });

          let variants = product.p_sku || [];
          const filter = (product.p_options_all || []).find(option => normalize(option.name) === normalize(product.filter_option));
          if (filter && product.filter_value) variants = variants.filter(variant => normalize(variant[`option${filter.position}`]) === normalize(product.filter_value));
          const firstVariant = variants[0];
          const firstImage = product.p_colors && firstVariant && firstVariant.featured_image ? firstVariant.featured_image.src : product.p_featured_image;
          colors.replaceChildren();
          if (product.p_colors && product.p_options) {
            const seen = new Set();
            variants.forEach(variant => {
              const color = variant[`option${product.p_options.position}`];
              const key = normalize(color);
              const colorEntry = Object.entries(product.p_colors).find(([name]) => normalize(name) === key);
              if (!colorEntry || seen.has(key)) return;
              seen.add(key);
              const button = document.createElement('button');
              const inner = document.createElement('span');
              const selected = seen.size === 1;
              button.type = 'button';
              button.className = 'color-btn size-14 !p-[3px] rounded-[7px] overflow-hidden';
              button.classList.toggle('active', selected);
              button.setAttribute('aria-label', `${product.title} ${color}`);
              button.setAttribute('aria-pressed', String(selected));
              inner.className = 'w-full h-full rounded-[7px]';
              inner.style.display = 'block';
              inner.style.backgroundColor = colorEntry[1];
              button.appendChild(inner);
              button.addEventListener('click', () => {
                if (version !== generation) return;
                colors.querySelectorAll('.color-btn').forEach(swatch => {
                  const active = swatch === button;
                  swatch.classList.toggle('active', active);
                  swatch.setAttribute('aria-pressed', String(active));
                });
                if (variant.featured_image) image.src = variant.featured_image.src;
                productLinks.forEach(link => {
                  link.dataset.selectedVariantUrl = `${product.link}?variant=${variant.id}`;
                });
              });
              colors.appendChild(button);
            });
          }
          image.onload = show;
          image.onerror = show;
          image.src = firstImage || '';
          revealTimer = setTimeout(show, 1800);
          if (image.complete || !fade || reducedMotion.matches) show();
        }

        indicators.forEach((indicator, i) => {
          indicator.classList.toggle('bg-[#f2cb04]', i === index);
          indicator.classList.toggle('bg-[#666666]', i !== index);
        });
        if (fade && !reducedMotion.matches) {
          elements.forEach(el => {
            el.classList.remove('opacity-100');
            el.classList.add('opacity-0');
          });
          timer = setTimeout(update, 300);
        } else update();
      }

      const previous = section.querySelector('#left-btn');
      const next = section.querySelector('#right-btn');
      if (previous) listen(previous, 'click', () => {
        current = (current - 1 + products.length) % products.length;
        render(current);
      });
      if (next) listen(next, 'click', () => {
        current = (current + 1) % products.length;
        render(current);
      });
      render(current, false);
    }
    listen(section, 'shopify:section:unload', () => {
      generation++;
      clearTimeout(timer);
      clearTimeout(revealTimer);
      if (image) image.onload = image.onerror = null;
      cleanups.forEach(cleanup => cleanup());
      delete section.dataset.homeCarouselReady;
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll(selector).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
